import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect as connectFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import chevronIcon from '../../images/chevron-down.svg';

import * as componentStyles from './FaqAccordion.style';

const FaqAccordion = ({ styles, questionId, answerId }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.item}>
            <button className={styles.header} onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
                <p className={styles.question}>
                    <FormattedMessage id={questionId} />
                </p>
                <img
                    src={chevronIcon}
                    alt=""
                    role="presentation"
                    className={`${styles.chevron}${isOpen ? ` ${styles.chevronOpen}` : ''}`}
                />
            </button>
            {isOpen && (
                <p className={styles.answer}>
                    <FormattedMessage id={answerId} />
                </p>
            )}
        </div>
    );
};

FaqAccordion.propTypes = {
    questionId: PropTypes.string.isRequired,
    answerId: PropTypes.string.isRequired,
};

export default connectFela(componentStyles)(FaqAccordion);
